'use client';

import { useEffect, useRef, useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const FloatingWelcomeMedia = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const tryPlayWithSound = () => {
      video.muted = false;
      video.volume = 1;
      video.play().catch(() => {
        // Most browsers block unmuted autoplay until a user interaction.
      });
    };

    tryPlayWithSound();

    const onFirstInteraction = () => {
      tryPlayWithSound();
      window.removeEventListener('pointerdown', onFirstInteraction);
      window.removeEventListener('keydown', onFirstInteraction);
    };

    window.addEventListener('pointerdown', onFirstInteraction);
    window.addEventListener('keydown', onFirstInteraction);

    return () => {
      window.removeEventListener('pointerdown', onFirstInteraction);
      window.removeEventListener('keydown', onFirstInteraction);
    };
  }, []);

  const closeWindow = () => {
    const video = videoRef.current;
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed top-24 right-4 z-50 group">
      <div className="w-[510px] md:w-[570px] overflow-hidden rounded-2xl border border-white/30 bg-black/55 shadow-2xl backdrop-blur-md">
        <div className="h-1 bg-gradient-to-r from-amber-400 to-orange-500" />

        <div className="relative">
          <video
            ref={videoRef}
            className="aspect-video w-full bg-black"
            src="/videos/legacy.mp4"
            autoPlay
            loop
            playsInline
            controls
          />

          <button
            onClick={closeWindow}
            aria-label="Close welcome media"
            className="absolute top-2 right-2 flex h-8 w-8 items-center justify-center rounded-full bg-black/65 text-white opacity-0 transition-opacity group-hover:opacity-100"
          >
            <Icon name="XMarkIcon" size={16} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default FloatingWelcomeMedia;